module.exports = __webpack_public_path__ + "img/moteasobu.9b87cd49.png";